import { Row, Col, Spinner, Button, Modal, Form } from "react-bootstrap"
import { useEffect, useState } from "react";
import Table from '../../../../../../components/Table';
import { Order } from "../../../../../../models/Order";
import { updateShoppingCart, ADD_ORDER_LINE, calculateOrderAction, updateOrderDetailsAction, UPDATE_ORDER_DETAILS, addOrderLineAction, UPDATE_SHOPPING_CART } from '../../../../../../redux/actions/orderManagement';
import { IActionResult, IAppState } from '../../../../../../redux/storeTypes';
import { connect, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { CurrencyFormatter } from "../../../../../../components/Formatters";
import { scrollToPaymentType } from "./StCharlesShoppingCart";
import { DateFormatter } from "./ForsythSearchResults";

interface IMathewsShoppingCart {
    title: string,
    subTitle: string,
    typeLabel: string,
    accountYearLabel: string,
    accountNumberLabel: string,
    ticketNumberFirst7Label: string,
    ticketNumberLast4Label: string,
    parcelIdLabel: string,
    nameLabel: string,
    addressLabel: string,
    modelLabel: string,
    totalAmountDueLabel: string,
    classLabel: string,
    valueLabel: string,
    actionsLabel: string,
    headerBackgroundColor: string,
    headerPadding: string,
    margin: string,
    padding: string,
    cartButtonBackgroundColor: string,
    cartButtonFontColor: string,
    cartButtonFontSize: string,
    cartButtonFontStyle: string,
    cartButtonFontWeight: string,
    cartButtonBorderColor: string,
    cartIconColor: string,
    actionResult: IActionResult,
    shoppingCart: any,
    order: Order,
}

export const TITLE = 'Shopping Cart';
export const SUBTITLE = ''
export const TYPE_LABEL = 'Type';
export const ACCOUNT_YEAR_LABEL = 'Account Year';
export const ACCOUNT_NUMBER_LABEL = 'Account Number';
export const PARCEL_ID_LABEL = 'Parcel ID';
export const TICKET_NUMBER_FIRST_7 = 'Ticket Number First7';
export const TICKET_NUMBER_LAST_4 = 'Ticket Number Last4';
export const NAME_LABEL = 'Name';
export const ADDRESS_LABEL = 'Address';
export const MODEL_LABEL = 'Model';
export const CLASS_LABEL = 'Class';
export const VALUE_LABEL = 'Value';
export const TOTAL_AMOUNT_DUE_LABEL = 'Total Amount Due';
export const ACTIONS_LABEL = 'Actions';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';
export const CART_BUTTON_FONT_COLOR = '#414141';
export const CART_BUTTON_FONT_SIZE = '.875rem';
export const CART_BUTTON_FONT_STYLE = 'normal';
export const CART_BUTTON_FONT_WEIGHT = 'normal';
export const CART_BUTTON_BORDER_COLOR = '#D9D9D9';
export const CART_BUTTON_BACKGROUND_COLOR = '#FFFFFF';
export const CART_ICON_COLOR = '#414141';


const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const checkStyleForDefault3 = (defaultStyle: string) => {
    return defaultStyle as any;
}

const MathewsShoppingCart = ({ title, subTitle, accountNumberLabel, typeLabel,ticketNumberFirst7Label, ticketNumberLast4Label, accountYearLabel, parcelIdLabel, nameLabel, addressLabel, modelLabel, classLabel, valueLabel, totalAmountDueLabel, actionsLabel,
    margin, padding, headerBackgroundColor, headerPadding, cartButtonBackgroundColor, cartButtonFontColor, cartButtonFontSize,
    cartButtonFontStyle, cartButtonFontWeight, cartButtonBorderColor, cartIconColor, shoppingCart, order, actionResult }: IMathewsShoppingCart) => {

    if (!title) { title = TITLE }
    if (!subTitle) { subTitle = SUBTITLE }
    if (!typeLabel) { typeLabel = TYPE_LABEL }
    if (!accountYearLabel) { accountYearLabel = ACCOUNT_YEAR_LABEL }
    if (!accountNumberLabel) { accountNumberLabel = ACCOUNT_NUMBER_LABEL }
    if (!parcelIdLabel) { parcelIdLabel = PARCEL_ID_LABEL }
    if (!nameLabel) { nameLabel = NAME_LABEL }
    if (!ticketNumberFirst7Label) { ticketNumberFirst7Label = TICKET_NUMBER_FIRST_7 }
    if (!ticketNumberLast4Label) { ticketNumberLast4Label = TICKET_NUMBER_LAST_4 }
    if (!addressLabel) { addressLabel = ADDRESS_LABEL }
    if (!modelLabel) { modelLabel = MODEL_LABEL }
    if (!classLabel) { classLabel = CLASS_LABEL }
    if (!valueLabel) { valueLabel = VALUE_LABEL }
    if (!totalAmountDueLabel) { totalAmountDueLabel = TOTAL_AMOUNT_DUE_LABEL }
    if (!actionsLabel) { actionsLabel = ACTIONS_LABEL }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }
    if (!cartButtonBackgroundColor) { cartButtonBackgroundColor = CART_BUTTON_BACKGROUND_COLOR }
    if (!cartButtonFontColor) { cartButtonFontColor = CART_BUTTON_FONT_COLOR }
    if (!cartButtonFontSize) { cartButtonFontSize = CART_BUTTON_FONT_SIZE }
    if (!cartButtonFontStyle) { cartButtonFontStyle = CART_BUTTON_FONT_STYLE }
    if (!cartButtonFontWeight) { cartButtonFontWeight = CART_BUTTON_FONT_WEIGHT }
    if (!cartButtonBorderColor) { cartButtonBorderColor = CART_BUTTON_BORDER_COLOR }
    if (!cartIconColor) { cartIconColor = CART_ICON_COLOR }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const amountFormatter = (cell: any) => {
        return (<span>{formatter.format(cell)}</span>)
    }

    const actionsFormatter = (cell: any, row: any) => {
        if (cell) {
            return (
                <Button size="sm" variant="outline-secondary" onClick={() => setDeleteRow(row)}>
                    Delete
                </Button>
            );
        }
    }

    const initialColumns = [{
        dataField: 'type',
        text: typeLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'accountYear',
        text: accountYearLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'accountNumber',
        text: accountNumberLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    },{
        dataField: 'ticketNumberFirst7',
        text: ticketNumberFirst7Label,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'ticketNumberLast4',
        text: ticketNumberLast4Label,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,

    }, {
        dataField: 'totalAmountDue',
        text: totalAmountDueLabel,
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        sort: true,
        formatter: amountFormatter,
    }, {
        dataField: 'paymentAmount',
        text: 'Amount',
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        sort: true,
        formatter: amountFormatter,
    }, {
        dataField: 'isDeletable',
        text: actionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        formatter: actionsFormatter,
        editable: false,
    }];


    const [columns, setColumns] = useState<any>(initialColumns);
    const dispatch = useDispatch();
    const [deleteRow, setDeleteRow] = useState<any>('');
    const actionToken = 'ItemShoppingCart';
    const [showModal, setShowModal] = useState<boolean>(false);


    useEffect(() => {
        if (shoppingCart && order) {
            const deletedAccountObject = shoppingCart.find((details: any) => details?.id == deleteRow?.id);
            let _shoppingCart = shoppingCart.map((shoppingCartDetails: any) => {
                if (shoppingCartDetails?.id != deleteRow?.id) {
                    return shoppingCartDetails
                }
            }).filter(Boolean)
            if (deletedAccountObject) {
                const nextYearObject = _shoppingCart.filter((details: any) => details?.accountNumber === deletedAccountObject.accountNumber).map((item: any) => ({'accountYear': item?.accountYear, 'ticketNumberLast4': item?.ticketNumberLast4}));
                const deletePrecedingRow = _.maxBy(nextYearObject, (item:any) => [item.accountYear,item.ticketNumberLast4])
                _shoppingCart.forEach((details: any) => {
                    if (details?.accountNumber === deletedAccountObject?.accountNumber) {
                        details.isDeletable = details?.type != 'RE' ? (details?.accountYear == deletePrecedingRow?.accountYear) : (details?.accountYear == deletePrecedingRow?.accountYear && details?.ticketNumberLast4 == deletePrecedingRow?.ticketNumberLast4)
                    }
                })
            }
            let _updatedOrderLines = order?.orderLines.map((orderDetails: any) => {
                if (orderDetails?.itemReferenceNumber != deleteRow?.id) {
                    return orderDetails
                }
            }).filter(Boolean)
            order.orderLines = _updatedOrderLines;
            dispatch(updateShoppingCart(_shoppingCart, actionToken));
            dispatch(updateOrderDetailsAction(order, actionToken));
           
        }
    }, [deleteRow]);

    useEffect(() => {
        if (actionResult && actionResult.type === ADD_ORDER_LINE) {
            dispatch(calculateOrderAction(actionToken));
        }
        if (actionResult && actionResult.type === UPDATE_ORDER_DETAILS) {
            dispatch(calculateOrderAction(actionToken));
        }
    }, [actionResult]);

    useEffect(() => {
        if(shoppingCart){
            setColumns([...initialColumns]);
        }
    }, [shoppingCart])

    const renderTable = () => {
        return (
            <>
                {shoppingCart?.length > 0 &&
                    <table className="table table-bordered">
                        <tbody>
                            <tr style={{ fontWeight: 'bold' }}>
                                <td></td>
                                <td style={{ float: 'right', marginRight: '20px', borderStyle: 'none' }}>Total : {CurrencyFormatter(_.sumBy(shoppingCart, 'paymentAmount'))}</td>
                                <td><Button size="sm" style={{ border: 'none', backgroundColor: '#f0ad4e' }} onClick={(e) => clearCart(e)}>Empty Cart</Button></td>
                            </tr>
                        </tbody>
                    </table>
                }
                <Table
                    keyField="id"
                    data={shoppingCart}
                    columns={columns}
                    remote={false}
                />
            </>
        );
    };

    const scrollToCheckout = (e: any) => {
        e.preventDefault();
        setShowModal(false);
        setTimeout(() => {
            scrollToPaymentType();
        }, 100);

    }

    const clearCart = (e: any) => {
        e.preventDefault();
        let order = new Order();
        order.orderLines = [];
        dispatch(updateShoppingCart([], actionToken));
        dispatch(updateOrderDetailsAction(order, actionToken));
    }

    return (
        <div style={{ margin: margin, padding: padding }}>
            {shoppingCart?.length > 0 &&
                <Row>
                    <Col>
                        <Button className="brand-btn-primary" style={{
                            marginTop: '29px',
                            backgroundColor: checkStyleForDefault(cartButtonBackgroundColor, CART_BUTTON_BACKGROUND_COLOR),
                            borderColor: checkStyleForDefault(cartButtonBorderColor, CART_BUTTON_BORDER_COLOR),
                            color: checkStyleForDefault(cartButtonFontColor, CART_BUTTON_FONT_COLOR),
                            fontSize: checkStyleForDefault(cartButtonFontSize, CART_BUTTON_FONT_SIZE),
                            fontStyle: checkStyleForDefault(cartButtonFontStyle, CART_BUTTON_FONT_STYLE),
                            fontWeight: checkStyleForDefault3(cartButtonFontWeight)
                        }} onClick={() => setShowModal(true)}>
                            <FontAwesomeIcon icon={faCartPlus} style={{ color: checkStyleForDefault(cartIconColor, CART_ICON_COLOR) }} className="btn-icon" />{`View Cart (${shoppingCart?.length})`}
                        </Button>
                    </Col>
                </Row>
            }
            <Modal show={showModal} size={'xl'} backdrop="static" onHide={() => setShowModal(false)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <Form.Group>
                        <div className="form-header">
                            <h2>{title}</h2>
                            <p>{subTitle}</p>
                        </div>
                        {renderTable()}
                        <div style={{ float: 'right' }}>
                            <Button style={{ marginRight: '8px' }} onClick={(e) => scrollToCheckout(e)}>Checkout</Button>
                            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Close</Button>
                        </div>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </div>

    )
}

const mapStateToProps = (state: IAppState) => {
    return {
        isSaving: state.orderManagement.isSaving,
        actionResult: state.orderManagement.actionResult,
        order: state.orderManagement.order,
        shoppingCart: state.orderManagement.shoppingCart
    };
};

export default connect(mapStateToProps)(MathewsShoppingCart);